export const optionsEvents = [
  {
    id: "1",
    description: "Reunião",
  },
  {
    id: "2",
    description: "Contratação",
  },
  {
    id: "3",
    description: "Instalação do App",
  },
  {
    id: "4",
    description: "Seleção",
  },
  {
    id: "5",
    description: "Validação",
  },
  {
    id: "6",
    description: "Coleta",
  },
  {
    id: "7",
    description: "Mudança de setor",
  },
  {
    id: "8",
    description: "Envio de Conteúdo",
  },
  {
    id: "9",
    description: "Envio de Trilha",
  },
  {
    id: "10",
    description: "Evento Esm",
  },
]